var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Indica") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Indica",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    id: "Combined-Shape-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62857143,18.5799025 C4.35167421,20.1678746 6.65534207,21.1380952 9.18647305,21.1380952 C14.527211,21.1380952 18.8545555,16.8202779 18.8545555,11.4937585 C18.8545555,6.33325414 14.7927536,2.119554 9.68279417,1.86190476 C11.5948541,3.62389148 12.7919829,6.14642257 12.7919829,8.94800386 C12.7919829,14.2745233 8.46463842,18.5923406 3.12390049,18.5923406 C2.95777772,18.5923406 2.79263476,18.5881614 2.62857143,18.5799025 Z",
    transform: "translate(10.741563, 11.500000) rotate(345.000000) translate(-10.741563, -11.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicaIcon);
export default __webpack_public_path__ + "static/media/indicaIcon.540f48d3aaedaeead62e94ce4eeac364.svg";
export { ForwardRef as ReactComponent };